import React from 'react';
import { Link } from 'react-scroll';
import ScrollCascade from './ScrollCascade.js';
import { isMobile, isChrome } from 'react-device-detect';

export default class Navbar extends React.Component {

  state = {
    mobileVisible: false,
  }

  render() {
    const { menu, children } = this.props;
    const { mobileVisible } = this.state;

    const links = menu.filter(({ hidden }) => !hidden)
    .map(({ title, page }, index) =>
      <Link
        key={index}
        href={page}
        className={"nav-item" + (mobileVisible ? ' animated fadeIn' : '')}
        smooth
        hashSpy={!isMobile}
        to={page}
        style={mobileVisible ? { marginRight: '5rem' } : {}}
      >
        {title}
      </Link>
    );

    return (
      <div className={`b-abs m-top m-right ${mobileVisible ? 'm-left' : ''}`}>
        <a role="button"
          onClick={() => {
            this.setState({ mobileVisible: !mobileVisible });
            if (this.props.toggleMobile) {
              this.props.toggleMobile(!mobileVisible);
            }
          }}
          className={`navbar-burger is-pulled-right is-hidden-tablet ${mobileVisible ? 'is-active' : ''}`}
          aria-label="menu" aria-expanded="false"
          style={{ width: '1.5rem', height: '1.5rem', zoom: '1.8', zIndex: 1 }}>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
        <nav
          className={`navigation is-size-3 is-size-4-touch is-unselectable animated-step-delay ${mobileVisible ? 'm-text-red' : 'is-hidden-mobile'}`}
        >
          <Link key="index" className="is-hidden" hashSpy={!isMobile} to="/" />
          { mobileVisible ?
            links
          : <ScrollCascade animateIn="fadeIn" animateOut="fadeOut" offset={50}>
            {links}
          </ScrollCascade>}
        </nav>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js